import imgOne from '../../assets/blogs/1.png';
import imgTwo from '../../assets/blogs/2.png';
import imgThree from '../../assets/blogs/3.png';

const BlogData = [
    {
        'img': imgOne,
        'url': 'dis-tedavilerinde-yeni-teknolojiler',
        'title':'Diş Tedavilerinde Yeni Teknolojiler',
        'description':'Dijital görüntüleme ve hassas planlama araçlarıyla daha konforlu tedavi süreçleri mümkün hale geliyor.',
        'category': 'TEKNOLOJİ'
    },
     {
        'img': imgTwo,
        'url':'duzenli-dis-bakimi-gulusunuzu-aydinlatir',
        'title':'Düzenli Diş Bakımı Gülüşünüzü Aydınlatır',
        'description':'Rutin kontroller ve doğru bakım alışkanlıkları sayesinde daha sağlıklı ve estetik bir gülüş elde edebilirsiniz.',
        'category': 'BAKIM'
    },
    {
        'img': imgThree,
        'url':'her-yas-icin-agiz-ve-dis-hijyeni',
        'title':'Her Yaş İçin Ağız ve Diş Hijyeni',
        'description':'Çocuklardan yetişkinlere kadar her yaşta uygulanabilecek hijyen önerileriyle dişlerinizi koruyun.',
        'category': 'HİJYEN'
    }
];

export default BlogData;